export default "__VITE_ASSET__8693e03d__"